<script>
import { Line, mixins } from 'vue-chartjs';

export default {
  name: 'StatisticGraph',
  extends: Line,
  mixins: [mixins.reactiveProp],
  props: {
    chartData: {
      type: Object,
      default: null
    },
    chartOptions: {
      type: Object,
      default: null
    }
  },
  watch: {
    chartData: {
      handler() {
        this.renderChart(this.chartData, this.chartOptions);
      },
      deep: true
    }
  },
  mounted() {
    this.renderChart(this.chartData, this.chartOptions);
  }
}
</script>